'use strict';

var _ = require('lodash');
var ChartModel = function ChartModel() {
  function BidPriceChartModel() {
    this.rawData = undefined;
    this.selectedLeg = undefined;
    this.selectedCabinCode = undefined;
  }
  BidPriceChartModel.prototype.data = function (value) {
    if (!arguments.length) {
      return this.rawData;
    }
    this.rawData = value;
    this.leg(this.legs().shift());
    this.cabinCode(this.cabinCodes().shift());
    return this;
  };
  BidPriceChartModel.prototype.leg = function (leg) {
    if (!arguments.length) {
      return this.selectedLeg;
    }
    this.selectedLeg = leg;
    this.cabinCode(this.cabinCodes().shift());
    return this;
  };
  BidPriceChartModel.prototype.cabinCode = function (cabinCode) {
    if (!arguments.length) {
      return this.selectedCabinCode;
    }
    this.selectedCabinCode = cabinCode;
    return this;
  };
  BidPriceChartModel.prototype.legs = function () {
    return _.chain(this.data()).uniqBy(function (entry) {
      return entry.leg;
    }).sortBy(function (leg) {
      return leg.sequence;
    }).transform(function (result, entry) {
      return result.push(entry.leg);
    }).value();
  };
  BidPriceChartModel.prototype.cabinCodes = function () {
    var leg = this.leg();
    return _.chain(this.data()).filter(function (legCabin) {
      return legCabin.leg === leg;
    }).uniqBy(function (legCabin) {
      return legCabin.cabinCode;
    }).sortBy(function (legCabin) {
      return legCabin.cabinIndex;
    }).transform(function (result, leg) {
      return result.push(leg.cabinCode);
    }).value();
  };
  BidPriceChartModel.prototype.getBidPricesList = function () {
    var leg = this.leg();
    var selectedCabinCode = this.selectedCabinCode;
    var currentSeatsAvail;
    if (this.selectedCabinCode) {
      return _.chain(this.data()).filter(function (legCabin) {
        return legCabin.leg === leg && legCabin.cabinCode === selectedCabinCode;
      }).transform(function (result, entry) {
        currentSeatsAvail = entry.seatsAvailableModel;
        return result.push(entry.bidPrices);
      }).last().tap(function (arr) {
        arr[0].currentSeatsAvail = currentSeatsAvail;
      }).value();
    } else {
      return _.chain(this.data()).filter(function (legCabin) {
        return legCabin.leg === leg;
      }).uniqBy(function (legCabin) {
        return legCabin.cabinCode;
      }).sortBy(function (legCabin) {
        return legCabin.cabinIndex;
      }).transform(function (result, entry) {
        currentSeatsAvail = entry.seatsAvailableModel;
        return result.push(entry.bidPrices);
      }).last().tap(function (arr) {
        arr[0].currentSeatsAvail = currentSeatsAvail;
      }).value();
    }
  };
  return BidPriceChartModel;
};
module.exports = ChartModel;